import { useContext } from "react";
import { Modal, Box } from "@mui/material";
import { fields } from "scenes/cohort-filters/filter-configs/fields.conf";
import { defaultRulePropertiesByWidgetType } from "scenes/cohort-filters/filter-configs/defaultRulePropertiesByWidgetType";
import { queryFormContext } from "scenes/cohort-filters/filter-state/context";
import { ADD_RULE } from "scenes/cohort-filters/filter-state/actions";
import { categoryLabels } from "scenes/cohort-filters/filter-configs/categories";
import { Trans, useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";
import Flex from "components/grid/Flex";

const categoriesWithFields = Object.entries(fields)
    .filter(([pathToValue, categoryConfig]) => categoryConfig.category)
    .reduce((acc, [pathToValue, categoryConfig]) => {
        /** categoryConfig:
         * {
         *  "widgetType":"dropdown",
         *  "category":"general",
         *  "widgetConfig":{
         *      "label":"anamnesis.general.genderLabel",
         *      "values":[
         *          {"value":"MAN","label":"global.male-bio-sex"},
         *          {"value":"WOMAN","label":"global.female-bio-sex"}
         *      ],
         *      "width":null
         *  }
         * }
         */
        return acc[categoryConfig.category]
            ? {
                  ...acc,
                  [categoryConfig.category]: [
                      ...acc[categoryConfig.category],
                      {
                          name: pathToValue,
                          label: categoryConfig.widgetConfig.label,
                      },
                  ],
              }
            : {
                  ...acc,
                  [categoryConfig.category]: [
                      {
                          name: pathToValue,
                          label: categoryConfig.widgetConfig.label,
                      },
                  ],
              };
    }, {});

const categoriesWithFieldsDescByEntrySize = Object.fromEntries(
    Object.entries(categoriesWithFields).sort((a, b) => b[1].length - a[1].length),
);

const useStyles = makeStyles((theme) => ({
    list: {
        listStyleType: "none",
        padding: "0 0 0 2px",
        margin: 0,
    },
    filterLink: {
        cursor: "pointer",
        "&:hover": {
            color: theme.palette.primary.main,
        },
        "&.disabled": {
            cursor: "initial",
            color: theme.palette.text.disabled,
        },
    },
}));

export const AddFilterModal = ({ formTree, isOpen, onClose }) => {
    const { dispatch } = useContext(queryFormContext);
    const classes = useStyles();
    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                display="grid"
                gridTemplateColumns="repeat(4, 1fr)"
                style={{ gap: "10px", padding: 20, margin: 20, backgroundColor: "white", borderRadius: "8px" }}
            >
                {Object.entries(categoriesWithFieldsDescByEntrySize).map(([categoryName, categoryFields]) => (
                    <Box key={categoryName} display="flex" flexDirection="column">
                        <span style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                            <Trans i18nKey={categoryLabels[categoryName] || categoryName} />
                        </span>
                        <ul className={classes.list}>
                            {categoryFields.map((field) => {
                                const fieldAlreadyExists = formTree.some(
                                    (rule) => rule.properties.field === field.name,
                                );
                                const rulePropertiesFromFieldsConfig = fields[field.name].defaultRuleProperties;
                                const rulePropertiesFromWidgetType =
                                    defaultRulePropertiesByWidgetType[fields[field.name].widgetType];
                                const defaultProperties = rulePropertiesFromFieldsConfig
                                    ? rulePropertiesFromFieldsConfig
                                    : rulePropertiesFromWidgetType
                                      ? rulePropertiesFromWidgetType
                                      : {};
                                return (
                                    <li
                                        className={`${classes.filterLink} ${fieldAlreadyExists ? "disabled" : ""}`}
                                        key={field.name}
                                        onClick={() => {
                                            if (fieldAlreadyExists) return;
                                            dispatch({
                                                type: ADD_RULE,
                                                payload: {
                                                    type: "rule",
                                                    properties: {
                                                        field: field.name,
                                                        value: "",
                                                        disabled: false,
                                                        ...defaultProperties,
                                                    },
                                                },
                                            });
                                            onClose();
                                        }}
                                    >
                                        {"- "}
                                        <Trans i18nKey={field.label} />
                                    </li>
                                );
                            })}
                        </ul>
                    </Box>
                ))}
            </Box>
        </Modal>
    );
};
